import React from 'react'
import NavLite from '../../components/NavLite'
import Footer from '../../components/Footer'

function WebsiteRefresh() {
  <main>
  <title>Website Refresh Services | Update & Modernize Your Site | Her Growth Co.</title>
<meta
name="description"
content="Give your site a fresh look. Our website refresh services help modernize design, improve UX, and optimize SEO."
/>
<meta
name="keywords"
content="refresh outdated websites, elevate your brand design, SEO and design makeover, website upgrades for consultants, web refresh for women entrepreneurs, rebranding your digital space, updated UX for coaches, modern site redesigns"
/>
</main>
  return (
    <div>
      <NavLite/>
      <div className="text-center items-center justify-center text-9xl mt-10">
            Coming Soon
            </div>
      <Footer/>
    </div>
  )
}

export default WebsiteRefresh